import { useEffect, useState } from 'react';

import { VoiceProvider } from '@Models/callerIds.models';
import { useGetVoiceProviderSettingQuery } from '@Services/settings.service';

const useVoiceProvider = (
  userId: string
): { userVoiceProvider: VoiceProvider | undefined; loading: boolean } => {
  const [userVoiceProvider, setUserVoiceProvider] = useState<VoiceProvider>();

  const {
    data: dataOfVoiceProvider,
    isLoading: loadingVoiceProvider,
    isFetching: fetchingVoiceProvider,
  } = useGetVoiceProviderSettingQuery(userId, {
    skip: !userId,
  });

  const loading = loadingVoiceProvider || fetchingVoiceProvider;

  useEffect(() => {
    if (
      !loading &&
      dataOfVoiceProvider &&
      dataOfVoiceProvider.voiceProviderName
    ) {
      setUserVoiceProvider((prev) => {
        if (prev !== dataOfVoiceProvider.voiceProviderName) {
          return dataOfVoiceProvider.voiceProviderName;
        }
        return prev;
      });
    }
  }, [dataOfVoiceProvider, loading]);

  return { userVoiceProvider, loading };
};

export default useVoiceProvider;
